module.exports = __webpack_public_path__ + "static/img/space.45280770.webp";